<div>
  <canvas *ngIf="!isLoading" baseChart height="100px" [datasets]="salesChartData"
    [labels]="salesBarChartLabels" [options]="barChartOptions" [plugins]="barChartPlugins" [legend]="barChartLegend"
    [chartType]="barChartType" [colors]="colors" (chartHover)="chartHovered($event)"
    (chartClick)="chartClicked($event)">
  </canvas>
  <div id="chart-tooltip"></div>
</div>
